import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { METER_TYPE_ERROR_CODES } from 'config/app-config';
import { actionUrl } from 'config/static-content';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

export const deEnergisedCardTestId = 'deEnergisedCardTestId';
export const deEnergisedCardCUCtaTestId = 'deEnergisedCardCUCtaTestId';
export const deEnergisedCardRTHCtaTestId = 'deEnergisedCardRTHCtaTestId';

const {
  MeterDeenergisedException,
  MeterMeasurementClassException,
  MHHSUnmeteredSuppliesException,
  MeterProfileClassException,
  MHHSMeterProfileClassException,
  MeterRelatedException
} = METER_TYPE_ERROR_CODES;

type DeEnergisedCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const DeEnergisedCard = ({ errors, name }: DeEnergisedCardProps) => {
  const OTHER_PRIORITY_ERRORS = [
    MeterMeasurementClassException,
    MHHSUnmeteredSuppliesException,
    MeterProfileClassException,
    MHHSMeterProfileClassException,
    MeterRelatedException
  ];
  const electricityErrors = errors.filter(
    (error) => error.keyword === 'Electricity'
  );
  const isDenergised = electricityErrors.some(
    (error) => error.code === MeterDeenergisedException
  );
  const filteredElectricityErrors = electricityErrors.filter((error) =>
    OTHER_PRIORITY_ERRORS.includes(
      error.code as typeof OTHER_PRIORITY_ERRORS[number]
    )
  );
  const isOtherPriorityError = filteredElectricityErrors.length > 0;
  const shouldShow =
    !!electricityErrors.length && isDenergised && !isOtherPriorityError;

  if (!shouldShow) {
    return null;
  }

  return (
    <NsStandout decoration="orange" data-testid="deEnergisedCardTestId">
      <>
        <h3>We can&apos;t provide you with an electricity quote</h3>
        <p>
          Your electricity meter is currently de-energised, if you think this
          isn&apos;t right, please contact your current supplier to change this.
          Once this has been fixed we&apos;ll be able to give you a quote.
        </p>
        <TrackedCta name={name}>
          <NsSecondaryCta
            href={actionUrl.bgHome}
            testId="deEnergisedCardRTHCtaTestId"
          >
            Return to home page
          </NsSecondaryCta>
        </TrackedCta>
      </>
    </NsStandout>
  );
};
